module.exports = __webpack_public_path__ + "static/media/HCMM575.5ee6a417.jpg";